import {MyPresenceWidget} from "./widgets/my-presence";
import {FridgeWidget, FridgeStandortWidget} from "./widgets/fridge";

export const widgets = {
    "auftragssystem:my-presence":  MyPresenceWidget,
    "auftragssystem:fridge":  FridgeWidget,
    "auftragssystem:fridge-gelnhausen":  FridgeStandortWidget,
    "auftragssystem:fridge-koeln":  FridgeStandortWidget,
};